import { Component, OnInit } from '@angular/core';
import { ItineraryHistoryService } from '../../services/itinerary-history.service';

@Component({
  selector: 'app-itinerary-history',
  templateUrl: './itinerary-history.component.html',
  styleUrls: ['./itinerary-history.component.scss']
})
export class ItineraryHistoryComponent implements OnInit {
  itineraryHistory: string;

  constructor(private service: ItineraryHistoryService) {}

  ngOnInit() {
    this.service.getItineraryHistory().subscribe((res) => {
      if (res) {
        this.itineraryHistory = res.replace(new RegExp('\n', 'gi'), (match) => '<br>');
      }
    });
  }
}
